import { render, staticRenderFns } from "./bpmeterweek.vue?vue&type=template&id=be3a4cb2&"
import script from "./bpmeterweek.vue?vue&type=script&lang=js&"
export * from "./bpmeterweek.vue?vue&type=script&lang=js&"
import style0 from "./bpmeterweek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports